import { MapTo } from '@adobe/aem-react-editable-components';
import PqDataEntryForm, { PqDataEntryFormEditConfig } from './PqDataEntryForm';

export default MapTo(
    'cob-corp-acquisition/components/creditonebank/pq-data-entry-form',
)(
    PqDataEntryForm,
    PqDataEntryFormEditConfig,
);